import { put, call } from 'redux-saga/effects';
import * as APIs from 'services/api';
import { logout } from 'redux/actions/auth';
import { updateApp } from 'redux/actions/app';

export function* refreshApp() {
  try {
    const response = yield call(APIs.getProfile);
    if (response.code === 200) {
      response.user.role = "client";
      response.user.notification_newdoc = true;
      response.user.notification_newsession = true;
      response.user.permission['formation']['enable'] = true;
      response.user.permission['homepage']['enable'] = true;
      response.user.permission['inspection']['enable'] = true;

      yield put(
        updateApp({
          profile: response.user,
          refreshed: true,
        }),
      );
    } else {
      yield put(logout());
    }
  } catch (error) {
    console.log(error)
    yield put(logout());
  }
}
